/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  FlaggedIds Selectors
 */

import type { State } from '@zcode/state-type'

export const selectFlaggedIds = (state: State) => state?.flaggedIds

export const selectFlaggedBuildings = (state: State) => {
  const flaggedIds = selectFlaggedIds(state)
  return flaggedIds?.flaggedBuildings
}

export const selectFlaggedListings = (state: State) => {
  const flaggedIds = selectFlaggedIds(state)
  return flaggedIds?.flaggedListings
}
